// @flow
import path from 'ramda/es/path';

import { appTypes } from 'app/common/api';

import * as activityTypes from './activity-types';


export type ActivityEvent = {
  uuid: string,
  description: string,
}

export type ActivityEvents = {
  [key: string]: ActivityEvent
}

const cabinet = {
  [activityTypes.ACE_FIRST_ACCESS]: {
    '/children': {
      uuid: '278c814e-5160-4bc9-82a9-5f48be4fced7',
      description: 'Первое посещение в течении дня страницы «Мои дети» / «Моя страница»',
    },
    '/dnevnik': {
      uuid: 'bee1e84b-18a3-4be3-b0c9-81ec71665d03',
      description: 'Первое посещение в течении дня «Электронного дневника»',
    },
    '/cafeteria': {
      uuid: 'f953faa9-9f8d-4159-98e8-cff7e95d12d3',
      description: 'Первое посещение в течении дня «Электронной столовой»',
    },
    '/access': {
      uuid: '7522496c-7e06-41d4-9aef-f62047b44ff7',
      description: 'Первое посещение в течении дня «Электронной проходной»',
    },
    '/events': {
      uuid: '008ec0b5-94e6-411c-9a57-118affe21429',
      description: 'Первое посещение в течении дня раздела «События»',
    },
  },
};

const events = {
  [appTypes.APP_TYPE_CABINET]: cabinet,
};

export const getEvents = (
  appType: string | void,
  activityType: $Values<typeof activityTypes>,
): ActivityEvents | void => path([appType, activityType], events);

export default events;
